export default "__VITE_ASSET__0c3b5e19__"